import { render, staticRenderFns } from "./ImageLink.vue?vue&type=template&id=24c083b6&scoped=true&lang=pug"
import script from "./ImageLink.vue?vue&type=script&lang=js"
export * from "./ImageLink.vue?vue&type=script&lang=js"
import style0 from "./ImageLink.styl?vue&type=style&index=0&id=24c083b6&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c083b6",
  null
  
)

export default component.exports